import { HttpErrorResponse } from '@angular/common/http';

export const SUBSCRIPTION_REQUIRED_CODE = 'SUBSCRIPTION_REQUIRED';
export const SUBSCRIPTION_REQUIRED_MESSAGE =
  'Tu prueba terminó. Suscribite para seguir cargando datos.';

/** True for the 402 the API sends to write requests of read-only accounts. */
export function isSubscriptionRequiredError(
  error: unknown,
): error is HttpErrorResponse {
  if (!(error instanceof HttpErrorResponse) || error.status !== 402) {
    return false;
  }
  const body: unknown = error.error;
  return (
    typeof body === 'object' &&
    body !== null &&
    (body as { code?: unknown }).code === SUBSCRIPTION_REQUIRED_CODE
  );
}
